import classNames from '@/utils/classNames';
import ButtonIcon from '@/components/Button/particles/ButtonIcon';
import BaseButton from '@/components/Button/particles/BaseButton';

import type { ComponentProps } from 'react';
import type { ButtonWithStaticIcon } from '@/components/Button/types';

const CLASSNAME =
  'bg-greyscale-900 not-disabled:text-white disabled:text-white/60 not-disabled:hover:bg-blue-800 focus-visible:outline-blue-800';

const GhostButton = (({
  className,
  ref,
  ...props
}: ComponentProps<typeof BaseButton>) => (
  <BaseButton
    ref={ref}
    loadingLight
    {...props}
    className={classNames(CLASSNAME, className)}
  />
)) as ButtonWithStaticIcon;

GhostButton.displayName = 'GhostButton';

GhostButton.Icon = ButtonIcon;

export default GhostButton;
